import { customLink, linkResolver } from '@lib/data/prismic/helpers';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.div<{ borderColor: string; bgColor: string }>`
  padding: 24px;
  background-color: ${(props) => props.bgColor};
  border-left: 4px solid ${(props) => props.borderColor};

  font-weight: lighter;

  .title {
    font-size: 21px;
    margin: 0;
    text-transform: uppercase;
  }

  p, li , ul{
    margin: 0;
    font-size: 14px;
  }

  *:last-child {
    margin-bottom: 0;
  }

  margin: 30px 0;
`;

export const ProsAndCons = ({
  pros,
  cons,
}: {
  pros?: ReactNode;
  cons?: ReactNode;
}) => (
  <>
    {pros && (
      <Container borderColor="#9eeac0" bgColor="#def9ea">
        <p className="title">
          <strong>Prós</strong>
        </p>
        {pros}
      </Container>
    )}
    {cons && (
      <Container borderColor="#ffbaba" bgColor="#ffeded">
        <p className="title">
          <strong>Contras</strong>
        </p>
        {cons}
      </Container>
    )}
  </>
);

const SliceProsCons = ({
  slice,
}: {
  slice: { primary: { pros?: RichTextBlock[]; cons?: RichTextBlock[] } };
}) => (
  <ProsAndCons
    pros={
      <RichText
        render={slice.primary.pros}
        linkResolver={linkResolver}
        serializeHyperlink={customLink}
      />
    }
    cons={
      <RichText
        render={slice.primary.cons}
        linkResolver={linkResolver}
        serializeHyperlink={customLink}
      />
    }
   />
);

export default SliceProsCons;
